import { Pipe, PipeTransform } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import {DevicePropertyVisibilityConfiguration} from '../../project/models/project-configuration';

@Pipe({
  name: 'treeDeviceTootip',
  pure: false
})
export class TreeDeviceTootipPipe implements PipeTransform {

  constructor (
    private translate: TranslateService
  ) {

  }

  transform(node: TreeNode, devicePropertyVisibilityConfigurations: DevicePropertyVisibilityConfiguration[]): string {

    const currentDeviceConfiguration = devicePropertyVisibilityConfigurations && devicePropertyVisibilityConfigurations.find(config => {
      return config.type === node?.data?.device?.type;
    });

    const hiddenProperties = currentDeviceConfiguration && currentDeviceConfiguration.hiddenProperties;
    let viewProperties = '';

    if (!(this._isPropertyHidden('hostname', hiddenProperties))) {
      viewProperties += `<strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_ZABBIX_HOST')} </strong>: <span class='pl-5 float-right'>${node.data.device?.hostname || ''} </span> <br>`
    }
    if (!(this._isPropertyHidden('ipAddr', hiddenProperties))) {
      viewProperties += `<strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_IP_ADDRESS')} </strong>: <span class='pl-5 float-right'>${node.data.device?.ipAddr || ''} </span> <br>`
    }
    if (!(this._isPropertyHidden('macAddr', hiddenProperties))) {
      viewProperties += `<strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_MAC_ADDRESS')} </strong>: <span class='pl-5 float-right'>${node.data.device?.macAddress || ''} </span> <br>`
    }
    if (!(this._isPropertyHidden('serial', hiddenProperties))) {
      viewProperties += `<strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_SERIAL')}  </strong>: <span class='pl-5 float-right'>${node.data.device?.serial || ''} </span> <br>`
    }
    if (!(this._isPropertyHidden('config', hiddenProperties))) {
      viewProperties += `<strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_CONFIG')}  </strong>: <span class='pl-5 float-right'>${node.data.device?.config || ''}  </span> <br>`
    }
    if (!(this._isPropertyHidden('firmware', hiddenProperties))) {
      viewProperties += `<strong> ${this.translate.instant('I18N_MONITORING.DEVICE_FIRMWARE')} </strong>: <span class='pl-5 float-right'>${node.data.device?.firmware || ''} </span> <br>`
    }
    if (!(this._isPropertyHidden('type', hiddenProperties))) {
      viewProperties += `<strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_TYPE')}  </strong>:  <span class='pl-5 float-right'>${node.data.device?.type || ''}  </span> <br>`
    }
    if (!(this._isPropertyHidden('paintedCoachId', hiddenProperties))) {
      viewProperties += `<strong>  ${this.translate.instant('I18N_MONITORING.PAINTED_CAR_NUMBER')}  </strong>: <span class='pl-5 float-right'>${node.data.device?.paintedCoachId || ''}  </span> <br>`
    }
    if (!(this._isPropertyHidden('position', hiddenProperties))) {
      viewProperties += `<strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_POSITION')}  </strong>: <span class='pl-5 float-right'>${node.data.device?.position || ''}  </span> <br>`
    }

    return viewProperties;
  }

  private _isPropertyHidden = (property , hiddenProperties) =>
  {
    return hiddenProperties && hiddenProperties.find(hiddenProperty => hiddenProperty === property);
  }

}
